import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerEventoConcesionService = async (values) => {
	return await instance.Backend.post(
		"/Indicador/ObtenerEventoConcesion",
		values,
		{
			...customConfig,
			validateStatus: () => true,
		},
	);
};

export { ObtenerEventoConcesionService };
